import React from "react";
import { connect } from "react-redux";
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";

//Componentes auxiliares:
import Navbar from "./static/Navbar";
import Footer from "./static/Footer";
import Sidebar from "./static/Sidebar";

//Rutas del layout:
import mainMenuRoutes from './menuRoutes/mainMenuRoutes';

//Variables auxiliares:
let myPerfectScrollbar;

class MainLayout extends React.Component {

  constructor(props) {
    super(props);

    let backgroundColor= "black"
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      backgroundColor= "linear-gradient(#66615B 0%, #000 80%) !important"
    } 
    this.state = {
      backgroundColor: backgroundColor,
      activeColor: "info"
    };
    this.mainPanel = React.createRef();
  }

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      myPerfectScrollbar = new PerfectScrollbar(this.mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      myPerfectScrollbar.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }

  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      this.mainPanel.current.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }
  }

  handleActiveClick = color => {
    this.setState({ activeColor: color });
  };

  handleBgClick = color => {
    this.setState({ backgroundColor: color });
  };

  render() {
    return (
      <div className="wrapper">
        <Sidebar {...this.props} mainMenuRoutes={mainMenuRoutes}
          bgColor={this.state.backgroundColor} style={{backgroundColor:this.state.backgroundColor}} activeColor={this.state.activeColor} />

        <div className="main-panel" ref={this.mainPanel}>
          <Navbar {...this.props} />
          <Switch>
            {mainMenuRoutes.map((route, key) => {
              return (
                <Route path={route.layout + route.path}
                  key={key} component={route.component} />
              );
            })}
          </Switch>
          <Footer fluid />
        </div>
        {/* <FixedPlugin
          bgColor={this.state.backgroundColor}
          activeColor={this.state.activeColor}
          handleActiveClick={this.handleActiveClick}
          handleBgClick={this.handleBgClick}
        /> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { activeUser: state.mainReducer.activeUser, };
};

export default connect(mapStateToProps)(MainLayout);
